var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "396.86 172.86 230.14 230.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2cf04dc52f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 396.855469 172.855469 L 626.992188 172.855469 L 626.992188 402.992188 L 396.855469 402.992188 Z M 396.855469 172.855469 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2cf04dc52f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3ab54a",
    d: "M 607.542969 287.925781 C 607.542969 340.648438 564.648438 383.542969 511.925781 383.542969 C 459.203125 383.542969 416.308594 340.648438 416.308594 287.925781 C 416.308594 235.203125 459.203125 192.308594 511.925781 192.308594 C 564.648438 192.308594 607.542969 235.203125 607.542969 287.925781 Z M 593.285156 206.566406 C 571.554688 184.832031 542.660156 172.863281 511.925781 172.863281 C 481.191406 172.863281 452.296875 184.832031 430.566406 206.566406 C 408.832031 228.296875 396.863281 257.191406 396.863281 287.925781 C 396.863281 318.660156 408.832031 347.554688 430.566406 369.285156 C 452.296875 391.015625 481.191406 402.984375 511.925781 402.984375 C 542.660156 402.984375 571.554688 391.015625 593.285156 369.285156 C 615.015625 347.554688 626.984375 318.660156 626.984375 287.925781 C 626.984375 257.191406 615.015625 228.296875 593.285156 206.566406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3ab54a",
    d: "M 562.957031 244.539062 L 499.871094 307.625 L 473.648438 281.40625 L 455.890625 299.167969 L 499.871094 343.148438 L 580.71875 262.300781 L 562.957031 244.539062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCropped);
export default __webpack_public_path__ + "static/media/success-cropped.bf45157749a9af1c0e74253d9cf04d08.svg";
export { ForwardRef as ReactComponent };